var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-splash',{attrs:{"title":"Verify Email Address"}},[_c('form',{staticClass:"h-full flex-col"},[_c('content-verify-thanks',{attrs:{"user":_vm.user,"resent":_vm.resent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }